var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4277 10.8004H8.75887L14.6753 4.62347C15.1596 4.11556 15.4318 3.42667 15.4318 2.70837C15.4318 1.99006 15.1596 1.30118 14.6753 0.793262C14.1909 0.285344 13.5339 0 12.8489 0C12.1639 0 11.5069 0.285344 11.0225 0.793262L0.733153 11.5826C0.498965 11.8391 0.31539 12.1416 0.192961 12.4727C-0.0643202 13.1294 -0.0643202 13.866 0.192961 14.5227C0.31539 14.8538 0.498965 15.1563 0.733153 15.4128L11.0225 26.2021C11.2617 26.4549 11.5462 26.6556 11.8596 26.7926C12.1731 26.9295 12.5093 27 12.8489 27C13.1885 27 13.5247 26.9295 13.8382 26.7926C14.1516 26.6556 14.4361 26.4549 14.6753 26.2021C14.9164 25.9514 15.1077 25.6531 15.2383 25.3244C15.3689 24.9957 15.4362 24.6431 15.4362 24.287C15.4362 23.9309 15.3689 23.5784 15.2383 23.2497C15.1077 22.921 14.9164 22.6227 14.6753 22.3719L8.75887 16.195H33.4277C34.1099 16.195 34.7642 15.9108 35.2466 15.405C35.729 14.8992 36 14.2131 36 13.4977C36 12.7823 35.729 12.0962 35.2466 11.5904C34.7642 11.0845 34.1099 10.8004 33.4277 10.8004Z",
    fill: "#F3DE8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackWhite);
export default __webpack_public_path__ + "static/media/arrow-back-white.bf996bee13e1ce82c9ce9e5dd958a846.svg";
export { ForwardRef as ReactComponent };